<div role="button" tabindex="0" [ngClass]="menu ? 'activity-container' : 'activity-container2'" (click)="$event.stopPropagation()">

    @if (loading) {
    <div class="loading-overlay">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading Activities...</p>
    </div>
    }

    <div class="activity-header">
        <span>Activity</span>

        <button class="sort-btn" mat-icon-button (click)="$event.stopPropagation()" [matMenuTriggerFor]="sortMenu"
            [disabled]="loading || activities.length === 0">
            <div class="flex">
                @if (sortType === 'newest') {
                <mat-icon class="grey rotate">sort</mat-icon>
                <mat-icon class="grey rotate">arrow_downward</mat-icon>
                } @else {
                <mat-icon class="grey">sort</mat-icon>
                <mat-icon class="grey">arrow_downward</mat-icon>
                }

            </div>
        </button>

        <mat-menu #sortMenu="matMenu" xPosition="before" yPosition="below">
            <button mat-menu-item (click)="sortChanged('newest'); $event.stopPropagation()">
                <mat-radio-button [checked]="sortType === 'newest'">Newest first</mat-radio-button>
            </button>

            <button mat-menu-item (click)="sortChanged('oldest'); $event.stopPropagation()">
                <mat-radio-button [checked]="sortType === 'oldest'">Oldest first</mat-radio-button>
            </button>
        </mat-menu>
    </div>

    <div class="activity-list">

        @if (activities.length === 0 && !loading) {
        <div class="no-activity">
            <p>No recent activity</p>
        </div>
        } @else {

        @for (a of activities; track a.userId) {
        @if (menu) {
        <div class="item">
            <div class="name">{{ a.firstName }} {{ a.lastName }}</div>
            <div class="remark">{{ a.remark }}</div>
            <div class="time">{{getTimeAgo(a.actionTime)}}</div>
        </div>
        } @else {
        <div class="item">
            <div class="name">{{ a.firstName }} {{ a.lastName }}</div>
            <div class="remark">{{ a.remark }}</div>
            <div class="time">{{getTimeAgo(a.actionTime)}}</div>
        </div>
        }
        }
        }

    </div>

    @if (enableLoadMore && !loading) {
    <div class="load-more">
        <button class="btn" mat-button (click)="loadMore()">Load more</button>
    </div>
    }

    @if (showViewAll) {
    <div class="view-all">
        <button class="btn" mat-raised-button (click)="viewAllClicked()">
            View all
        </button>
    </div>
    }

</div>